import { Injectable } from '@angular/core';
import { SharedAppInitialisationService } from '@shared-services/app-initialisation.service';

/**
 * The app initialisation service that handles all logic that should be ran/initialized
 * on start of the application & when the user is authenticated
 *
 * Is initialized in the InternalComponent
 */
@Injectable()
export class InternalAppInitialisationService {
	constructor(private readonly sharedAppInitialisationService: SharedAppInitialisationService) {}

	public async initialize(): Promise<void> {
		const isActive = await this.sharedAppInitialisationService.userIsActive();
		if (isActive) {
			await this.sharedAppInitialisationService.getUserDetails();
		}
	}
}
